import { TCanvasLink } from "../types/TCanvasLink";
import { TLink } from "../types/TLink";
// import createLinkId from "./createLinkId";
import createNodeId from "./createNodeId";

export default function parseLinks(data: TLink[]): TCanvasLink[] {
  return data.map(item => parseLink(item))
}

export function parseLink(data: TLink): TCanvasLink {
  return {
    id: data.id,
    link_type: "foreign",
    source: createNodeId(data.source, 'COLUMN'),
    target: createNodeId(data.target, 'COLUMN'),
    payload: data.payload ? [data.payload] : [],
    accuracy: data.accuracy
  }
}
